export default function EmptyState({ icon = '📋', title, message, action }) {
  return (
    <div
      className="card center"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
        padding: '32px 20px',
      }}
    >
      <div style={{ fontSize: 40, lineHeight: 1 }} aria-hidden>
        {icon}
      </div>
      {title && <h3 style={{ fontSize: 17 }}>{title}</h3>}
      {message && (
        <p className="muted" style={{ margin: 0, fontSize: 14 }}>
          {message}
        </p>
      )}
      {action && <div className="mt-8">{action}</div>}
    </div>
  )
}
